import tenant from "./Tenant"

export default { tenant }